export enum TripTypeEnum {
	Broken = 'broken',
	Bypassed = 'bypassed',
	Canceled = 'canceled',
	Standard = 'standard'
}
